import {
  Sheet,
  SheetTrigger,
  SheetContent,
} from "../../../../../components/ui/sheet";
import EventTileDrawer from "./EventTileDrawer";
import { IEvents } from "@/models/IEvents";
import { formatEventDateRange } from "../../../../../utils/date";

const EventTile = ({ data }: { data: IEvents }) => {
  // const getWeekday = (dateStr: string) => {
  //     const date = new Date(dateStr);
  //     return date.toLocaleDateString("en-US", { weekday: "short" });
  // };

  return (
    <Sheet>
      <SheetTrigger asChild>
        <div
          role="button"
          className="col-span-12 md:col-span-4 border border-border-stone rounded-[0.5rem] flex flex-col p-4 gap-2 bg-[#f9fbfc] h-[10.75rem] cursor-pointer transition-transform duration-300 ease-out
            hover:scale-[1.03]
            hover:shadow-lg
            hover:z-10
            will-change-transform"
        >
          <div
            className={`text-sm leading-5 font-normal border-none px-2 py-1 rounded-full w-fit ${data.category == "Conference" ? "text-[#00758A] bg-[#E6F3F9]" : data.category == "Webinar" ? "text-[#9C1349] bg-[#FCEDEE]" : "text-[#00758A] bg-[#E6F3F9]"}`}
          >
            {data.category}
          </div>
          <h3 className="text-[#14181a] font-bold text-base">{data.name}</h3>
          <div className="text-sm text-[#2A2E86] leading-5">
            {formatEventDateRange(data)}
          </div>
          <div className="text-sm leading-5 font-normal text-[#606C73]">
            {data.address_line1}
          </div>
        </div>
      </SheetTrigger>
      <SheetContent
        className="bg-white border border-border-stone w-[80%] md:w-[70%] lg:w-[50%] max-w-none"
        side="right"
      >
        <EventTileDrawer data={data} />
      </SheetContent>
    </Sheet>
  );
};

export default EventTile;
